import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Home from "../pages/Home";
import About from "../pages/About";
import Services from "../pages/Services";
import Blogs from "../pages/Blogs";
import Blog1 from "../pages/Blog1";
import Blog2 from "../pages/Blog2";
import Blog3 from "../pages/Blog3";
import Blog4 from "../pages/Blog4";
import Contact from "../pages/Contact";
import Disclaimer from "../pages/Disclaimer";
import Privacy from "../pages/Privacy";

const pageTransition = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
  transition: { duration: 0.38 },
};

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div {...pageTransition}>
              <Home />
            </motion.div>
          }
        />
        <Route
          path="/about"
          element={
            <motion.div {...pageTransition}>
              <About />
            </motion.div>
          }
        />
        <Route
          path="/services"
          element={
            <motion.div {...pageTransition}>
              <Services />
            </motion.div>
          }
        />
        <Route
          path="/blogs"
          element={
            <motion.div {...pageTransition}>
              <Blogs />
            </motion.div>
          }
        />
        <Route
          path="/blog/blog1"
          element={
            <motion.div {...pageTransition}>
              <Blog1 />
            </motion.div>
          }
        />
        <Route
          path="/blog/blog2"
          element={
            <motion.div {...pageTransition}>
              <Blog2 />
            </motion.div>
          }
        />
        <Route
          path="/blog/blog3"
          element={
            <motion.div {...pageTransition}>
              <Blog3 />
            </motion.div>
          }
        />
        <Route
          path="/blog/blog4"
          element={
            <motion.div {...pageTransition}>
              <Blog4 />
            </motion.div>
          }
        />
        <Route
          path="/contact"
          element={
            <motion.div {...pageTransition}>
              <Contact />
            </motion.div>
          }
        />
        <Route
          path="/disclaimer"
          element={
            <motion.div {...pageTransition}>
              <Disclaimer />
            </motion.div>
          }
        />
        <Route
          path="/privacy"
          element={
            <motion.div {...pageTransition}>
              <Privacy />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
